import React, { Component } from 'react';
import { Button } from 'react-md';
import styles from '../css/styles.css.js';
import LoadingSpinner from '../component/LoadingSpinner';
import ApiRequestService from '../component/ApiRequestService';
import { AppProperties } from '../common/function';
import { browserHistory } from 'react-router';
import '../css/searchBar.css'



export default class SearchBar extends Component {
  appProperties = AppProperties();
  baseFolder = this.appProperties.baseFolder;
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            showSuggestion: false,
            keyword: '',
            topicIdParams: 0,
            subjectIdParams: 0,
            categoryIdParams: 0,
            subCategoryIdParams: 0,
            questionIdParams: 0,
            subject_name: '',
            topic_name: '',
            category_name: '',
            subcategory_name: '',
            url: '',
            filterBreadcrumb: '',
            suggestionArray: [],
            archive_id:parseInt(this.props.location.query.archive_id,10),
            archive_mode:this.props.location.query.archive_mode,
        };
    }
    componentWillMount() {

      if(this.props.location !== undefined 
        && this.props.location !== null
        && this.props.location.query !== undefined 
        && this.props.location.query !== null 
        ) {
          if(this.props.location.query.topic_id !== undefined && this.props.location.query.topic_id !== null) {
            this.state.topicIdParams = parseInt(this.props.location.query.topic_id, 10);
            this.state.topic_name = this.props.location.query.topic_name;

          }
          if(this.props.location.query.subject_id !== undefined && this.props.location.query.subject_id !== null) {
            this.state.subjectIdParams =  parseInt(this.props.location.query.subject_id, 10);
            this.state.subject_name = this.props.location.query.subject_name;
          }
          if(this.props.location.query.category_id !== undefined && this.props.location.query.category_id !== null) {
            this.state.categoryIdParams= parseInt(this.props.location.query.category_id, 10);
            this.state.category_name = this.props.location.query.category_name;
          }
          if(this.props.location.query.subcategory_id !== undefined && this.props.location.query.subcategory_id !== null) {
              this.state.subCategoryIdParams = parseInt(this.props.location.query.subcategory_id, 10);
              this.state.subcategory_name = this.props.location.query.subcategory_name;
            }
        }
    }
    componentDidUpdate() {
      if(this.props.location !== undefined 
        && this.props.location !== null
        && this.props.location.query !== undefined 
        && this.props.location.query !== null 
        )  {
          if(this.props.location.query.archive_id !== undefined && this.props.location.query.archive_id !== null) {
            this.state.archive_id = parseInt(this.props.location.query.archive_id,10)
          }
          if(this.props.location.query.archive_mode !== undefined && this.props.location.query.archive_mode !== null) {
            this.state.archive_mode = this.props.location.query.archive_mode
          }
        }
    }
    keywordOnchange(e) {

      this.state.suggestionArray = [];
      this.state.showSuggestion = false;
      this.setState({
        keyword: e.target.value
      });
    }

    suggestionHyperlink  = (searchResults) => {
      if (
        searchResults.suggestion_priority === 5 &&
        searchResults.subjectID === this.state.subjectIdParams &&
        searchResults.topicId === this.state.topicIdParams &&
        searchResults.categoryId === this.state.categoryIdParams &&
        searchResults.subCategoryId === this.state.subCategoryIdParams) {
          browserHistory.push(this.baseFolder + searchResults.searchResultsUrl);
          browserHistory.go(this.baseFolder + searchResults.searchResultsUrl);
        } else {
          browserHistory.push(this.baseFolder + searchResults.searchResultsUrl);
        }
      this.setState({
        showSuggestion : false,
      })
      this.state.suggestionArray = []
    }

    getsuggestionWithkeyword = () => {
      this.setState({
        showSuggestion : true,
      })
      this.setState({
        loading: true
      });
      if (this.state.keyword === '') {
        this.setState({
          showSuggestion : false,
          loading: false
        })
      }
      const payload = {
        search_keyword: this.state.keyword,
        subject_id: this.state.subjectIdParams,
        topic_id: this.state.topicIdParams,
        category_id: this.state.categoryIdParams,
        subcategory_id: this.state.subCategoryIdParams,
      }

      ApiRequestService({
        method: 'post',
        url: '/questionBankSearchByKeyword',
        data: payload
      })
        .then(res => {
          if (
              res && res.data && res.data.data
          ) {
            let response = res.data.data;
            for (let suggestion of response) {
              switch (suggestion.suggestion_priority) {

                case 1:
                  this.state.suggestionArray.push({
                    suggestion_priority : suggestion.suggestion_priority,
                    suggestion_category :"Subject Name ",
                    suggestion_keyword: suggestion.subjectName,
                    searchResultsCrumb: `${suggestion.subjectName}`,
                    searchResultsUrl: 
                    `topics?`
                    +`&subject_id=${parseInt(suggestion.subject_id)}`
                    +`&subject_name=${suggestion.subjectName}`
                    +`&archive_mode=${this.state.archive_mode}&archive_id=${this.state.archive_id}`,
                    subjectID : suggestion.subject_id,
                    topicId : suggestion.topic_id ,
                    categoryId : suggestion.category_id ,
                    subCategoryId : suggestion.subcategory_id ,
                    questionId : suggestion.question_id,
                  })
                  break;
                case 2:
                  this.state.suggestionArray.push({
                    suggestion_priority : suggestion.suggestion_priority,
                    suggestion_category :"Topic Name",
                    suggestion_keyword: suggestion.topicName,
                    searchResultsCrumb: `${suggestion.subjectName} -> ${suggestion.topicName}`,
                    searchResultsUrl: `category?topic_id=${parseInt(suggestion.topic_id)}`+
                    `&subject_id=${parseInt(suggestion.subject_id)}`
                    +`&subject_name=${suggestion.subjectName}`
                    +`&topic_name=${suggestion.topicName}`
                    +`&archive_mode=${this.state.archive_mode}&archive_id=${this.state.archive_id}`,
                    subjectID : suggestion.subject_id,
                    topicId : suggestion.topic_id ,
                    categoryId : suggestion.category_id ,
                    subCategoryId : suggestion.subcategory_id ,
                    questionId : suggestion.question_id,
                  })
                  break;
                case 3:
                  this.state.suggestionArray.push({
                    suggestion_priority : suggestion.suggestion_priority,
                    suggestion_category :"Category Name",
                    suggestion_keyword: suggestion.categoryName,
                    searchResultsCrumb: `${suggestion.subjectName} -> ${suggestion.topicName} -> ${suggestion.categoryName}`,
                    searchResultsUrl: `subCategory?topic_id=${parseInt(suggestion.topic_id)}`
                    +`&subject_id=${parseInt(suggestion.subject_id)}`
                    +`&category_id=${parseInt(suggestion.category_id)}`
                    +`&subject_name=${suggestion.subjectName}`
                    +`&topic_name=${suggestion.topicName}`
                    +`&category_name=${suggestion.categoryName}`
                    +`&archive_mode=${this.state.archive_mode}&archive_id=${this.state.archive_id}`,
                    subjectID : suggestion.subject_id,
                    topicId : suggestion.topic_id ,
                    categoryId : suggestion.category_id ,
                    subCategoryId : suggestion.subcategory_id ,
                    questionId : suggestion.question_id,
                  })
                  break;
                case 4:
                  this.state.suggestionArray.push({
                    suggestion_priority : suggestion.suggestion_priority,
                    suggestion_category :"SubCategory Name",
                    suggestion_keyword: suggestion.subcategoryName,
                    searchResultsCrumb: `${suggestion.subjectName} -> ${suggestion.topicName} -> ${suggestion.categoryName} -> ${suggestion.subcategoryName}`,
                    searchResultsUrl: `SubCategoryDetails?topic_id=${parseInt(suggestion.topic_id)}`
                    +`&subject_id=${parseInt(suggestion.subject_id)}`
                    +`&category_id=${parseInt(suggestion.category_id)}`
                    +`&subject_name=${suggestion.subjectName}`
                    +`&topic_name=${suggestion.topicName}`
                    +`&category_name=${suggestion.categoryName}`
                    +`&archive_mode=${this.state.archive_mode}&archive_id=${this.state.archive_id}`
                    +`&subcategory_id=${parseInt(suggestion.subcategory_id)}&subcategory_name=${suggestion.subcategoryName}`,
                    subjectID : suggestion.subject_id,
                    topicId : suggestion.topic_id ,
                    categoryId : suggestion.category_id ,
                    subCategoryId : suggestion.subcategory_id ,
                    questionId : suggestion.question_id,
                  })
                  break;
                  case 5:
                    this.state.suggestionArray.push({
                      suggestion_priority : suggestion.suggestion_priority,
                      suggestion_category :"Question Name",
                      suggestion_keyword: suggestion.question_name,
                      searchResultsCrumb: `${suggestion.subjectName} -> ${suggestion.topicName} -> ${suggestion.categoryName} -> ${suggestion.subcategoryName}  ->  ${suggestion.question_name}`,
                      searchResultsUrl: `SubCategoryDetails?topic_id=${parseInt(suggestion.topic_id)}`
                      +`&subject_id=${parseInt(suggestion.subject_id)}`
                      +`&category_id=${parseInt(suggestion.category_id)}`
                      +`&subject_name=${suggestion.subjectName}`
                      +`&topic_name=${suggestion.topicName}`
                      +`&category_name=${suggestion.categoryName}`
                      +`&archive_mode=${this.state.archive_mode}&archive_id=${this.state.archive_id}`
                      +`&question_id=${parseInt(suggestion.question_id)}`
                      +`&subcategory_id=${parseInt(suggestion.subcategory_id)}&subcategory_name=${suggestion.subcategoryName}`,
                      subjectID : suggestion.subject_id,
                      topicId : suggestion.topic_id ,
                      categoryId : suggestion.category_id ,
                      subCategoryId : suggestion.subcategory_id ,
                      questionId : suggestion.question_id,
                    })
                    break;

              }
            }
          }
            this.setState({
                loading: false
            })
          })
          .catch(error => {
            console.log('error: ' + JSON.stringify(error));
          }).finally(()=>{
            // this.setState({
            //     loading: false
            // })
        });
    }
 renderSuggestionBox = () => {
  if (this.state.loading){
    return(
      <div style={styles.suggestionLoading}>
        <LoadingSpinner loading={this.state.loading} style={{width:"1px"}} />
      </div>
    )
  } else if (this.state.suggestionArray.length === 0) {
    return (
      <div style={styles.suggestionNoResults}> No results Found</div>
    )

  } else {
    return(
        <div>
            {this.state.suggestionArray.map((suggestion) => (

              <a style={styles.suggestionHyperlink}>
                  <div onClick={() => this.suggestionHyperlink(suggestion)} style={styles.suggestionTile}>
                        <div>
                            <div style={styles.suggestionTitlecontent}>
                              <div style={styles.suggestionContent}>{suggestion.suggestion_keyword}<p style={styles.suggestionKeyword}></p></div>
                                  <div style={styles.suggestionContentName}
                                  style={suggestion.suggestion_priority === 1 ? styles.searchSubjectTagName :
                                    suggestion.suggestion_priority === 2 ? styles.searchTopicTagName :
                                    suggestion.suggestion_priority === 3 ? styles.searchCategoryName :
                                    suggestion.suggestion_priority === 4 ? styles.searchSubCategoryName :
                                    suggestion.suggestion_priority === 5 ? styles.searchQuestionName : ""
                                  }
                                  >
                                    
                                    {suggestion.suggestion_category}
                                  
                                  </div>
                            </div>
                        <div style={styles.suggestionBoxCrumbContent} >
                        <p style={styles.suggestionTitlesCrumb}>{suggestion.searchResultsCrumb}</p>
                        </div>
                    </div>

                  </div>
              </a>
            ))}
        </div>
    )

  }
        
 }
    render() {
        return(
          <div style={styles.searchBarComponent}>
            <div className='searchBarWrapper' style={styles.searchBarWrapper}>
                    <div style={styles.searchBar}>
                        <div style={styles.inputContainer}>
                          <input placeholder='Enter a Keyword to Search Question' onKeyPress={(e) => e.key === 'Enter' && this.getsuggestionWithkeyword()} onChange={(e) => {this.keywordOnchange(e)}} style={styles.inputFieldSearch} type="search"/> 
                        </div>
                        <div style={styles.searchButtonContainer}>
                              <Button className='searchButton' style={styles.searchButton} onClick={this.getsuggestionWithkeyword} primary raised >
                                search
                              </Button>
                        </div>
                    </div>
            </div>
            {(this.state.showSuggestion ) ? 
            (<div style={styles.suggestionContainer}>
              <div className='suggestionBox' style={styles.suggestionBox}>
                <div>
                  {this.renderSuggestionBox()} 
                </div>
              </div>
            </div>) : null
            }

          </div>
        );
      }
    
}